import { CommonModule } from '@angular/common';
import {
  Component,
  HostListener,
  OnInit,
  computed,
  inject,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import {
  GridModule,
  FilterService,
  PageService,
  PageSettingsModel,
  FilterSettingsModel,
} from '@syncfusion/ej2-angular-grids';
import { DateRangePickerAllModule } from '@syncfusion/ej2-angular-calendars';
import { SearchListItem, GlobalSearchService } from './global-search.service';
import { AdmitStatusBadgeComponent } from './components/admit-status-badge/admit-status-badge.component';

@Component({
  selector: 'lib-search',
  imports: [
    CommonModule,
    GridModule,
    FormsModule,
    DateRangePickerAllModule,
    AdmitStatusBadgeComponent,
  ],
  standalone: true,
  providers: [PageService, FilterService],
  templateUrl: './global-search.component.html',
  styleUrl: './global-search.component.css',
})
export class GlobalSearchComponent implements OnInit {
  private readonly searchService = inject(GlobalSearchService);

  readonly dateRange = signal<[Date | null, Date | null]>([null, null]);

  // Matches the CSS calc(100vh - 250px) grid height
  private readonly GRID_OFFSET_PX = 250;
  // Syncfusion default row height, filter bar, and pager bar
  private readonly ROW_HEIGHT_PX = 36;
  private readonly CHROME_PX = 90; // filter row (~42px) + pager bar (~48px)

  private readonly pageSize = signal<number>(this.computePageSize());
  readonly pageSettings = computed<PageSettingsModel>(() => ({
    pageSize: this.pageSize(),
  }));
  readonly filterSettings: FilterSettingsModel = { type: 'FilterBar' };
  tableData = signal<Array<SearchListItem>>([]);

  @HostListener('window:resize')
  onResize(): void {
    this.pageSize.set(this.computePageSize());
  }

  private computePageSize(): number {
    const availableHeight =
      window.innerHeight - this.GRID_OFFSET_PX - this.CHROME_PX;
    return Math.max(1, Math.floor(availableHeight / this.ROW_HEIGHT_PX));
  }

  ngOnInit(): void {
    this.searchService.getList().subscribe((data) => {
      console.log('🚀 ~ SearchComponent ~ ngOnInit ~ data:', data);
      this.tableData.set(data);
    });
  }
}
